import React from 'react';

import './footer.scss';

const Footer = () => {
    return (
        <div className="footer text-center pt-3 pb-3">
            <label className="title">&#169; 2020 Flume</label>
        </div>
    );
};

export default Footer;
